import { createFileRoute } from "@tanstack/react-router";
import PoolDeckRemodeling from "@/pages/PoolDeckRemodeling";
import { buildHead } from "@/lib/seo";

const areaServed = [
  { "@type": "City", name: "Fort Lauderdale" },
  { "@type": "City", name: "Coral Springs" },
  { "@type": "City", name: "Pembroke Pines" },
  { "@type": "City", name: "Weston" },
  { "@type": "City", name: "Miramar" },
  { "@type": "City", name: "Sunrise" },
  { "@type": "City", name: "Davie" },
  { "@type": "City", name: "Miami" },
  { "@type": "City", name: "Tampa" },
  { "@type": "City", name: "Orlando" },
];

export const Route = createFileRoute("/services/pool-deck-remodeling")({
  head: () =>
    buildHead({
      title:
        "Pool Deck Remodeling in Broward County, FL | Precision Pavers & Pool Design",
      description:
        "Transform your pool deck with resurfacing, repair, expansion, and custom design. Precision Pavers & Pool Design serves Fort Lauderdale, Coral Springs, Weston, and all of Broward County. Free estimates.",
      path: "/services/pool-deck-remodeling",
      jsonLd: [
        {
          "@context": "https://schema.org",
          "@type": "Service",
          serviceType: "Pool Deck Remodeling",
          provider: {
            "@type": "HomeAndConstructionBusiness",
            name: "Precision Pavers & Pool Design",
            url: "https://precisionpaverspools.com/",
          },
          areaServed,
          url: "https://precisionpaverspools.com/services/pool-deck-remodeling",
          description:
            "Expert Pool Deck Remodeling services in Broward County, FL. Free estimates.",
        },
        {
          "@context": "https://schema.org",
          "@type": "BreadcrumbList",
          itemListElement: [
            {
              "@type": "ListItem",
              position: 1,
              name: "Home",
              item: "https://precisionpaverspools.com/",
            },
            {
              "@type": "ListItem",
              position: 2,
              name: "Services",
              item: "https://precisionpaverspools.com/services",
            },
            {
              "@type": "ListItem",
              position: 3,
              name: "Pool Deck Remodeling",
              item: "https://precisionpaverspools.com/services/pool-deck-remodeling",
            },
          ],
        },
      ],
    }),
  component: PoolDeckRemodeling,
});
